module.exports = __webpack_public_path__ + "assets/img/logo-eternia.8c855717.webp";